export enum DocumentGetFormRequestContractsActionTypes {
  request = 'document/form-request-contracts/GET/REQUEST',
  success = 'document/form-request-contracts/GET/SUCCESS',
  failure = 'document/form-request-contracts/GET/FAILURE',
  cancel = 'document/form-request-contracts/GET/CANCEL',
}
